<template><div><h1 id="benutzergruppen" tabindex="-1"><a class="header-anchor" href="#benutzergruppen"><span>Benutzergruppen</span></a></h1>
<p>Benutzergruppen — Stammtabelle der Benutzergruppen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die Benutzergruppen definiert. Der Benutzergruppe sind <RouteLink to="/referenz/refs/ft.refdata.benutzerfunktionen.html" title="Benutzerfunktionen">Benutzerfunktionen</RouteLink> zugeodnet. Durch die Zuordnung der Benutzerfunktion zur Benutzergruppe kann eine neue Funktion direkt und einfach mehreren Benutzern gleichzeitig zugeordnet werden. Diese Zuordnung wird im Frame <RouteLink to="/referenz/refs/ft.refdata.benutzerfunktzuo.html" title="Benutzerfunktionen zuordnen">Benutzerfunktionen zuordnen</RouteLink> vorgenommen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Benutzergruppen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Gruppe</dt>
<dd>Kurzzeichen für Benutzergruppe, 4 Zeichen lang</dd>
<dt>Gruppenbezeichnung</dt>
<dd>Textfeld für Beschreibung der Gruppe</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink></p>
</div></template>


